export default function staticDiv(local) {
  local.text = local.string ? local.string : local;
}
